<template>
  <div style="transition: 0.4s; z-index: 200;" class="flex-1 bg-white rounded-xl space-y-6 p-6 tip-block plan-mask-box" :class="`step1`">
    <p v-if="selectLang == 'zh-TW'">此區塊為您目前所使用的方案名稱與使用期限，初次註冊，系統會給予免費體驗15天，以及1個行銷活動的使用額度。</p>
    <p v-if="selectLang == 'zh-CN'">此区块为您目前所使用的方案名称与使用期限，初次注册，系统会给予免费体验15天，以及1个行销活动的使用额度。</p>
    <p v-if="selectLang == 'en-US'">This block is the name and usage period of the plan you are currently using. For the first registration, the system will give you 15 days of free experience and a quota for marketing activities.</p>
    <div class="tip-footer">
      <button
        :style="{ opacity: nowStep === 1 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        :disabled="nowStep !== 1"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button>
      <button
        v-if="nowStep == 1"
        class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400 float-right"
        @click="next()"
      >
        下一步
      </button>
    </div>
  </div>
</template>

<script>
// import * as contentData from '@/components/Tips/marketingMethods.json';

export default {
  name: 'PlanMask',
  props: {
    nowStep: {
      type: Number,
      default: 1
    },
    selectLang: {
      type: String
    }
  },
  data() {
    return {
      nextText: '下一步',
      finishText: '完成',
      closeTipsText: '跳過教學'
    }
  },
  computed: {
    // content() {
    //   const data = contentData.default.filter(e => e.step === this.nowStep);
    //   let message;
    //   if (data.length > 0) {
    //     message = data[0].content_zh_TW;
    //     if(this.selectLang == 'en-US'){
    //       this.nextText = 'next';
    //       this.finishText = 'finish';
    //       this.closeTipsText = 'skip teaching';

    //       message = data[0].content_en_US;
    //     }
    //   } else {
    //     message = '';
    //   }
    //   return message;
    // }
  },
  methods: {
    next() {
      this.$emit('nextStep');
      // this.nowStep = this.nowStep + 1;
    },
    closeTips(){
      this.$emit('closeTips', false);
    }
  }
};

</script>

<style lang="scss">

.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 100;
}

.plan-mask-box {
  width: 320px;
  height: 200px;
}

@media (max-width: 1023px) {
  .plan-mask-box {
    width: calc(100vw - 2rem);
    max-width: 320px;
    height: auto;
  }
}

.step1 {
  position: absolute;
  top: 200px;
  left: 550px;
}

@media (max-width: 1023px) {
  .step1 {
    left: 50%;
    transform: translateX(-50%);
    top: 10vh;
  }
}

/*.step2 {
  position: absolute;
  top: 33vh;
  left: 26vw;
}*/

.step3 {
  position: absolute;
  top: 33vh;
  left: 36vw;
}

.step4 {
  position: absolute;
  top: 33vh;
  left: 46vw;
}

.step5 {
  position: absolute;
  top: 33vh;
  left: 56vw;
}

/* .step6 {
  position: absolute;
  top: 50vh;
  left: 56vw;
} */

.step6 {
  position: absolute;
  top: 28vh;
  left: 34vw;
}

.tip-footer {
  /*display: flex;*/
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

</style>
